module.exports = __webpack_public_path__ + "img/35.3aeb116f.jpg";